import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(
  _ => ({
    backdrop: {
      "& > div:first-child": {
        marginBottom: 12
      },
      display: "flex",
      flexDirection: "column",
      gap: "2px",
      color: "#fff",
      zIndex: 2000
    }
  }),
  { name: "ExportAllBackdrop" }
);
